import React, { useEffect, useState } from "react";
import { RefInfoDetailStyled, TransactionStatusStyled } from "./style";
var statuses = [
    { color: "#EC008C", text: "Aceptada" },
    { color: "#E1251B", text: "Rechazada" },
    { color: "#32184B", text: "Pendiente" },
    { color: "#E1251B", text: "Abandonada" },
    { color: "#E1251B", text: "Cancelada" },
    { color: "#E1251B", text: "Fallida" },
];
var TransactionStatus = function (_a) {
    var status = _a.status, nRef = _a.nRef, refEpayco = _a.refEpayco, isRefLogin = _a.isRefLogin;
    var _b = useState({
        color: "",
        text: "",
    }), statusInfo = _b[0], setStatusInfo = _b[1];
    useEffect(function () {
        handleStatus(status);
    }, [status]);
    var handleStatus = function (status) {
        var statusSelected = statuses.find(function (statusCase) { return statusCase.text === status; });
        statusSelected && setStatusInfo(statusSelected);
    };
    return (React.createElement(TransactionStatusStyled, { color: statusInfo.color },
        React.createElement("h2", null,
            "Transacci\u00F3n ",
            React.createElement("span", null, statusInfo.text)),
        React.createElement(RefInfoDetailStyled, null,
            React.createElement("p", null,
                React.createElement("span", null,
                    " ",
                    isRefLogin ? "N°. ref:" : "N° línea:"),
                " ",
                nRef)),
        React.createElement("div", { className: "ref-epayco" },
            React.createElement("p", null, "Referencia ePayco"),
            " ",
            React.createElement("span", null, refEpayco))));
};
export default TransactionStatus;
